import React from 'react'
import PropTypes from 'prop-types'

import ProjectExpenseListItem from "./ProjectExpenseListItem";

const ProjectExpensesList = ({data, onEdit, onDownload, onDelete, downloading, project_id}) => {

    return (

        <div className="d-flex flex-column">
            {data && data.map(expense => <ProjectExpenseListItem {...expense} onEdit={onEdit} onDownload={onDownload} onDelete={onDelete} downloading={downloading} project_id={project_id}/>)}
        </div>

    )

}

ProjectExpensesList.propTypes = {
    project_id: PropTypes.string.isRequired,
    onEdit: PropTypes.func,
    onDownload: PropTypes.func,
    onDelete: PropTypes.func,
    downloading: PropTypes.bool,
}

export default ProjectExpensesList